import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ShareArticleSection } from "../ShareArticleSection";

const SalesforceAmazonConnectIntegrationAndIntelligentBotDeployment = () => {
  return (
    <div className="modal-content-body case-studies-blk">
      <div className="modal-section">
        <div className="flex-content header-modal-case-studies">
          <div className="logo-section-modal">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/sentral-thumbnail-iris.png"
              alt="Scene to believe"
            />
          </div>
          <div>
            <h3>
              Salesforce-Amazon Connect Integration and Intelligent Bot
              Deployment
            </h3>
            <p>
              Sentral and iCXeed unified customer support with Salesforce,
              Amazon Connect, and Bedrock-powered self-service, delivering
              smarter digital support and greater efficiency.
            </p>
            <ShareArticleSection />
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Company Snapshot:</h2>
        <p className="title-description-blk">
          Sentral partnered with iCXeed to transform its customer support,
          integrating Salesforce Service Cloud Voice and Omnichannel with Amazon
          Connect into a unified contact centre and deploying advanced customer
          self-service using Amazon Bedrock. This solution enabled digital
          channel expansion, personalized automated support, and significant
          operational efficiency improvements.
        </p>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <div className="flex-content-half">
          <div>
            <h2 className="modal-section-title">Challenge:</h2>
            <p>
              Sentral's entire ecosystem was built on Salesforce, operating on
              Amazon Connect for voice-only interactions. The company identified
              critical gaps in their customer engagement strategy and approached
              iCXeed with specific requirements:
            </p>

            <br />
            <br />

            <ul>
              <li>
                • Maintain their existing Salesforce ecosystem while expanding
                capabilities
              </li>
              <li>
                • Enable comprehensive digital channel support beyond voice
              </li>
              <li>
                • Implement intelligent automation to handle routine customer
                inquiries
              </li>
              <li>
                • Transition to a true omnichannel contact centre solution
              </li>
              <li>
                • Improve operational efficiency while maintaining service
                quality
              </li>
            </ul>

            <br />
            <br />

            <p>
              The organisation recognised that many voice interactions could be
              more effectively handled through a unified omnichannel solution
              with automated self-service options, creating an opportunity to
              transform their customer experience approach and reduce their
              total cost of operations while increasing customer convenience.
            </p>
          </div>
          <div>
            <h2 className="modal-section-title">AWS Solution:</h2>
            <p>
              iCXeed leveraged the strategic partnership between Salesforce and
              AWS to deliver an integrated omnichannel solution:
            </p>

            <br />
            <br />

            <p>Core Implementation:</p>
            <ul>
              <li>
                • Deployed Salesforce's Service Cloud Voice and Omnichannel
                Contact Centre integrated with Amazon Connect for unified
                customer interactions. This integration maintained the preferred
                customer views within the Salesforce interface while leveraging
                Amazon Connect's advanced omnichannel interaction routing
                capabilities and intelligence.
              </li>
              <br />
              <br />
              <li>
                • Built a digital genAI self-service concierge on Amazon Bedrock
                to handle over 250 customer inquiries. This solution offered the
                following capabilities:
              </li>
              <br />
              <br />
              <li>
                • Leveraged Sentral's complete Salesforce knowledge base to
                enable contextual relevant responses
              </li>
              <li>
                • Implemented advanced personalisation that factored customer
                context on specific Sentral product configuration
              </li>
              <li>
                • Integrated the experience within the Sentral user interface
              </li>
              <br />
              <br />
              <li>• Delivered enhanced analytics & operations capabilities:</li>
              <li>• Enabled conversation analytics for quality insights</li>
              <li>• Implemented automated QA evaluations</li>
              <li>
                • Added forecasting for capacity planning and intelligent
                scheduling
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="outcomes-result-blk">
        <h2 className="modal-section-title">Outcomes/Results:</h2>
        <ul>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>40% volume reduction through self-service automation</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Higher agent engagement and retention</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>10% faster voice channel resolution</p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>Context-aware, personalized support at scale</p>
            </div>
          </li>
        </ul>
      </div>

      <div className="modal-footnote use-cases-footnote" style={{ border: 0 }}>
        <h4>Client Testimonial</h4>
        <h1>
          “Working with iCXeed has been a seamless and collaborative experience.
          Their team has consistently brought clarity and momentum to our AI and
          CX initiatives, project managing with precision and solving challenges
          proactively. Their support has been key to accelerating our
          innovation.”
        </h1>
        <div className="flex-box-blk client-details">
          <div>
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/lucy-pickering.png"
              alt="Stefan Hutton"
            />
          </div>
          <div>
            <h2>Lucy Pickering</h2>
            <p>Service Delivery Manager</p>
            <p>Sentral</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesforceAmazonConnectIntegrationAndIntelligentBotDeployment;
